import { WithStyles, withStyles } from '@mui/styles';

import { InvalidUser } from './invalidUser';
import { muiStyles } from './styles';

export type InvalidUserProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(InvalidUser);